<script lang="ts" setup>
import ChatMessage from "@src/types/ChatMessage";
import Document from "@src/components/ui/message-types/Document.vue";
import Location from "@src/components/ui/message-types/Location.vue";
import Audio from "@src/components/ui/message-types/Audio.vue";
import Sticker from "@src/components/ui/message-types/Sticker.vue";
import Video from "@src/components/ui/message-types/Video.vue";
import CostumerContact from "@src/components/ui/message-types/CostumerContact.vue";
import Contact from "@src/components/ui/message-types/Contact.vue";
import GroupMessage from "@src/types/GroupMessage";
import {computed} from "vue";
import {useChatSessionStore} from "@src/stores/chatSession";
import Link from "@src/components/ui/message-types/Link.vue";
import Image from "@src/components/ui/message-types/Image.vue";

const props = defineProps<{
    message: ChatMessage | GroupMessage;
    preview: boolean;
    self?: boolean;
}>();

const sessionStore = useChatSessionStore();

const isGroup = computed(() => sessionStore.type === 'group');

const message = computed(() => isGroup.value ? props.message.content : props.message.message)
</script>

<template>
    <div>
        <div v-if="props.message.type === 'image'">
            <Image :id="props.message.id" :data="message" :is-group="isGroup" :pane="false" :preview="props.preview"/>
        </div>
        <div v-if="props.message.type === 'document'">
            <Document :id="props.message.id" :data="message" :is-group="isGroup" :pane="false"
                      :preview="props.preview"/>
        </div>
        <div v-if="props.message.type === 'location'">
            <Location :json="message" :preview="props.preview"/>
        </div>
        <div v-if="props.message.type === 'audio'">
            <Audio :id="props.message.id" :data="message" :preview="props.preview"/>
        </div>
        <div v-if="props.message.type === 'sticker'">
            <Sticker :data="message" :preview="props.preview"/>
        </div>
        <div v-if="props.message.type === 'video'">
            <Video :id="props.message.id" :data="message" :pane="false" :preview="props.preview"/>
        </div>
        <div v-if="props.message.type === 'contact'">
            <Contact :id="message" :preview="props.preview"/>
        </div>
        <div v-if="props.message.type === 'vcard'">
            <CostumerContact :contact="message" :preview="props.preview"/>
        </div>
        <div v-if="props.message.type === 'link'">
            <Link :data="message" :preview="props.preview"/>
        </div>
    </div>
</template>
